/* @flow */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
	BtnClose,
	ButtonsGroup,
	ButtonsGroupTitle,
	ButtonsWrapper,
	DislikeButtons,
	DislikeSvg,
	DislikesWrapper,
	FormWrapper,
	HeadLineWrapper,
	PopupImg,
	SelectBtn,
	SelectBtnWrapper,
	Text,
	Title,
	TitleWrapper,
} from './styles';
import Check from '../../Check';
import type { TLiraNotice } from '../../../types/lira3';
import type { TDispatch } from '../../../types/core';
import { LIRA_SET_POPUP } from '../../../constants';
import { toggleArrayValue } from '../../../utils';
import { dislikeMediumIcon } from '../../Icons';
import Button from '../../Button2.0';
import Chat from '../../../../public/images/services/Chat.png';
import Chat2x from '../../../../public/images/services/Chat@2x.png';
import Chat3x from '../../../../public/images/services/Сhat@3x.png';

type TProps = {
	apartId: string,
	onClose?: () => {},
	onEmptyDislikeClick?: () => {},
	size?: string,
	withCheck?: boolean,
	noticeList?: TLiraNotice,
	className?: string,
	withCloseBtn?: boolean,
	hide?: () => {},
	withCloseBtnBottom?: boolean,
};

const DislikesPopUp = ({
	apartId,
	onClose,
	withCheck,
	noticeList,
	onEmptyDislikeClick,
	className,
	size,
	withCloseBtn,
	hide,
	withCloseBtnBottom,
}: TProps) => {
	const dispatch: TDispatch = useDispatch();
	const notices: string[] = useSelector((state) => state.liraPopups?.apartNotices[apartId]);

	const [withNotices, setWithNotices] = useState(false);

	const onNoticeChange = (key: string) => (): any => {
		const result = notices ? [...notices] : [];
		dispatch({
			type: LIRA_SET_POPUP,
			payload: { notices: [...toggleArrayValue(result, key)], apartId },
		});
	};

	useEffect(() => {
		setWithNotices(notices?.length > 0);
	}, [notices]);

	return (
		<FormWrapper className={className}>
			<HeadLineWrapper>
				<PopupImg>
					<img src={Chat} srcSet={`${Chat}, ${Chat2x} 2x, ${Chat3x} 3x`} alt="Вопрос" />
				</PopupImg>
				<TitleWrapper>
					<Title className={className}>Вам не понравилась эта квартира, почему?</Title>
					<Text>Система учтет ваши замечания</Text>
				</TitleWrapper>

				{withCloseBtn && (
					<BtnClose type="button" onClick={hide}>
						<span aria-hidden="true">&times;</span>
					</BtnClose>
				)}
			</HeadLineWrapper>
			<DislikesWrapper>
				{noticeList &&
					Object.keys(noticeList)?.map((key: string) => {
						const dislikes = noticeList[key];
						return (
							<ButtonsGroup key={key}>
								<ButtonsGroupTitle className={className}>{key}</ButtonsGroupTitle>
								<DislikeButtons>
									{dislikes.map((item: TLiraNotice) => (
										<SelectBtnWrapper
											key={item.key}
											onClick={onNoticeChange(item.key)}
											isActive={notices?.includes(item.key)}
										>
											<DislikeSvg viewBox="0 0 22 22" isShow={notices?.includes(item.key)}>
												{dislikeMediumIcon}
											</DislikeSvg>
											<SelectBtn isActive={notices?.includes(item.key)}>{item.title}</SelectBtn>
										</SelectBtnWrapper>
									))}
								</DislikeButtons>
							</ButtonsGroup>
						);
					})}
			</DislikesWrapper>
			<ButtonsWrapper>
				{withCheck && <Check checked label="Больше не спрашивать" />}
				<Button size={size} onClick={withNotices ? onClose : onEmptyDislikeClick}>
					Готово
				</Button>
				{withCloseBtnBottom && (
					<Button size={size} onClick={hide} color="white">
						Закрыть
					</Button>
				)}
			</ButtonsWrapper>
		</FormWrapper>
	);
};

DislikesPopUp.defaultProps = {
	onClose: undefined,
	withCheck: false,
	noticeList: undefined,
	size: 'm',
	className: null,
	onEmptyDislikeClick: () => {},
	withCloseBtn: false,
	hide: () => {},
	withCloseBtnBottom: false,
};

export default DislikesPopUp;
